__turbopack_context__.v({
  "canvas": "AtelierBottleStage-module__ZByrWG__canvas",
  "caption": "AtelierBottleStage-module__ZByrWG__caption",
  "still": "AtelierBottleStage-module__ZByrWG__still",
});
